/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggers } from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggers';

/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseNinjaOne
 */
export interface GetIntegrationsConfig200ResponseNinjaOne {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    hasClientSecret: boolean;
    /**
     * 
     */
    hasUserConnection: boolean;
    /**
     * 
     */
    connectedAt?: string;
    /**
     * 
     */
    clientId: string;
    /**
     * 
     */
    region: GetIntegrationsConfig200ResponseNinjaOneRegionEnum;
    /**
     * 
     */
    organizationId?: number;
    /**
     * 
     */
    defaultStatus: GetIntegrationsConfig200ResponseNinjaOneDefaultStatusEnum;
    /**
     * 
     */
    ticketType: GetIntegrationsConfig200ResponseNinjaOneTicketTypeEnum;
    /**
     * 
     */
    ticketFormId?: number;
    /**
     * 
     */
    triggers: GetIntegrationsConfig200ResponseTehtrisTriggers;
}


/**
 * @export
 */
export const GetIntegrationsConfig200ResponseNinjaOneRegionEnum = {
    Eu: 'eu',
    Us: 'us',
    Ca: 'ca',
    Oc: 'oc',
} as const;
export type GetIntegrationsConfig200ResponseNinjaOneRegionEnum = typeof GetIntegrationsConfig200ResponseNinjaOneRegionEnum[keyof typeof GetIntegrationsConfig200ResponseNinjaOneRegionEnum];

/**
 * @export
 */
export const GetIntegrationsConfig200ResponseNinjaOneDefaultStatusEnum = {
    New: 'NEW',
    Open: 'OPEN',
    Waiting: 'WAITING',
    Paused: 'PAUSED',
    Resolved: 'RESOLVED',
    Closed: 'CLOSED',
} as const;
export type GetIntegrationsConfig200ResponseNinjaOneDefaultStatusEnum = typeof GetIntegrationsConfig200ResponseNinjaOneDefaultStatusEnum[keyof typeof GetIntegrationsConfig200ResponseNinjaOneDefaultStatusEnum];

/**
 * @export
 */
export const GetIntegrationsConfig200ResponseNinjaOneTicketTypeEnum = {
    Problem: 'PROBLEM',
    Question: 'QUESTION',
    Incident: 'INCIDENT',
    Task: 'TASK',
} as const;
export type GetIntegrationsConfig200ResponseNinjaOneTicketTypeEnum = typeof GetIntegrationsConfig200ResponseNinjaOneTicketTypeEnum[keyof typeof GetIntegrationsConfig200ResponseNinjaOneTicketTypeEnum];


/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseNinjaOne interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseNinjaOne(value: object): value is GetIntegrationsConfig200ResponseNinjaOne {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('hasClientSecret' in value) || value['hasClientSecret'] === undefined) return false;
    if (!('hasUserConnection' in value) || value['hasUserConnection'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('defaultStatus' in value) || value['defaultStatus'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    if (!('triggers' in value) || value['triggers'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseNinjaOneFromJSON(json: any): GetIntegrationsConfig200ResponseNinjaOne {
    return GetIntegrationsConfig200ResponseNinjaOneFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseNinjaOneFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseNinjaOne {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'hasClientSecret': json['hasClientSecret'],
        'hasUserConnection': json['hasUserConnection'],
        'connectedAt': json['connectedAt'] == null ? undefined : json['connectedAt'],
        'clientId': json['clientId'],
        'region': json['region'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'defaultStatus': json['defaultStatus'],
        'ticketType': json['ticketType'],
        'ticketFormId': json['ticketFormId'] == null ? undefined : json['ticketFormId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json['triggers']),
    };
}

export function GetIntegrationsConfig200ResponseNinjaOneToJSON(json: any): GetIntegrationsConfig200ResponseNinjaOne {
    return GetIntegrationsConfig200ResponseNinjaOneToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseNinjaOneToJSONTyped(value?: GetIntegrationsConfig200ResponseNinjaOne | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'hasClientSecret': value['hasClientSecret'],
        'hasUserConnection': value['hasUserConnection'],
        'connectedAt': value['connectedAt'],
        'clientId': value['clientId'],
        'region': value['region'],
        'organizationId': value['organizationId'],
        'defaultStatus': value['defaultStatus'],
        'ticketType': value['ticketType'],
        'ticketFormId': value['ticketFormId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(value['triggers']),
    };
}

